import type { ComponentType } from "react";
import Image from "next/image";
import { PeeqdToolId } from "@/config/peeqdContent";
import type { PeeqdReportTabId, PeeqdContentTabId } from "@/config/peeqdContent";

export function TrackerIcon({ className = "w-[18px] h-[18px]" }: { className?: string }) {
  return (
    <svg className={`ic ${className} text-muted transition-colors`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" opacity=".5" />
      <path d="M19 8v6M22 11h-6" />
    </svg>
  );
}

export function StoriesIcon({ className = "w-[18px] h-[18px]" }: { className?: string }) {
  return (
    <svg className={`report-tab-icon ic ${className} text-muted transition-colors`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  );
}

export function CompetitorsIcon({ className = "w-[18px] h-[18px]" }: { className?: string }) {
  return (
    <svg className={`ic ${className} text-muted transition-colors`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
      <circle cx="12" cy="12" r="9" />
    </svg>
  );
}

export function AuditIcon({ className = "w-[18px] h-[18px]" }: { className?: string }) {
  return (
    <svg className={`ic ${className} text-muted transition-colors`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
      <path d="M22 12A10 10 0 0 0 12 2v10z" />
    </svg>
  );
}

export function ContentIcon({ className = "w-[18px] h-[18px]" }: { className?: string }) {
  return (
    <svg className={`report-tab-icon ic ${className} text-muted transition-colors`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
    </svg>
  );
}

export function LikesIcon({ className = "w-[18px] h-[18px]" }: { className?: string }) {
  return (
    <svg className={`report-tab-icon ic ${className} text-muted transition-colors`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
  );
}

export function UnfollowsIcon({ className = "w-[18px] h-[18px]" }: { className?: string }) {
  return (
    <svg className={`report-tab-icon ic ${className} text-muted transition-colors`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 11h-6" />
    </svg>
  );
}

export function CommentsIcon({ className = "w-[18px] h-[18px]" }: { className?: string }) {
  return (
    <svg className={`report-tab-icon ic ${className} text-muted transition-colors`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  );
}

export function InstagramIcon({ className = "w-5 h-5" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function TikTokIcon({ className = "w-5 h-5" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z" />
    </svg>
  );
}

export function CheckIcon({ className = "w-4 h-4 text-mint" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}

const TOOL_ICONS: Record<string, React.ComponentType<{ className?: string }>> = {
  tracker: TrackerIcon,
  stories: StoriesIcon,
  competitors: CompetitorsIcon,
  audit: AuditIcon,
  "followers-following": TrackerIcon,
  "story-alerts": StoriesIcon,
  "competitor-watch": CompetitorsIcon,
  "audience-audit": AuditIcon,
};

export function ToolIcon({ icon, className }: { icon: string; className?: string }) {
  const Icon = TOOL_ICONS[icon] ?? TrackerIcon;
  return <Icon className={className} />;
}

export function toolIdFromSlug(slug: string): PeeqdToolId {
  const map: Record<string, PeeqdToolId> = {
    "followers-following": "followers-following",
    "story-alerts": "story-alerts",
    "competitor-watch": "competitor-watch",
    "audience-audit": "audience-audit",
  };
  return map[slug] ?? "followers-following";
}

const REPORT_TAB_ICONS: Record<PeeqdReportTabId, ComponentType<{ className?: string }>> = {
  stories: StoriesIcon,
  comments: CommentsIcon,
  content: ContentIcon,
  likes: LikesIcon,
  unfollows: UnfollowsIcon,
};

export function ReportTabIcon({ tab, className }: { tab: PeeqdReportTabId; className?: string }) {
  const Icon = REPORT_TAB_ICONS[tab];
  return <Icon className={className} />;
}

export function PostsTabIcon({ className = "w-4 h-4" }: { className?: string }) {
  return (
    <svg className={`content-tab-icon ${className} text-muted transition-colors`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <path d="m21 15-5-5L5 21" />
    </svg>
  );
}

export function ReelsTabIcon({ className = "w-4 h-4" }: { className?: string }) {
  return (
    <svg className={`content-tab-icon ${className} text-muted transition-colors`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="2.18" />
      <path d="M10 8l6 4-6 4V8z" />
    </svg>
  );
}

export function HighlightsTabIcon({ className = "w-4 h-4" }: { className?: string }) {
  return (
    <svg className={`content-tab-icon ${className} text-muted transition-colors`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6v6l4 2" />
    </svg>
  );
}

export function RepostsTabIcon({ className = "w-4 h-4" }: { className?: string }) {
  return (
    <svg className={`content-tab-icon ${className} text-muted transition-colors`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 1l4 4-4 4" />
      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
      <path d="M7 23l-4-4 4-4" />
      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
    </svg>
  );
}

const CONTENT_TAB_ICONS: Record<PeeqdContentTabId, ComponentType<{ className?: string }>> = {
  stories: StoriesIcon,
  posts: PostsTabIcon,
  reels: ReelsTabIcon,
  highlights: HighlightsTabIcon,
  reposts: RepostsTabIcon,
};

export function ContentTabIcon({ tab, className }: { tab: PeeqdContentTabId; className?: string }) {
  const Icon = CONTENT_TAB_ICONS[tab];
  return <Icon className={className} />;
}

export function PeeqdLogoIcon({ className = "h-8 w-8" }: { className?: string }) {
  return (
    <Image
      src="/assets/logo-icon.svg"
      alt=""
      aria-hidden
      width={100}
      height={100}
      className={`shrink-0 ${className}`}
    />
  );
}
